import { useFlag } from '@calendly/feature-check-react';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useEventType } from 'features/event_type_provider';
import { AdvancedNotificationSection, BasicNotificationsSection } from '../../notifications';
const containerCss = "c1nw9l2k";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});

// onSubmit is used through the managed ET form, not always needed
export const Notifications = ({
  workflows,
  onSubmit
}) => {
  const managedEventTypeWorkflowsEnabled = useFlag('raven_admin_managed_workflows_feature');
  const {
    isMETParent
  } = useEventType();
  const hasWorkflows = workflows?.list && workflows.list.length > 0;
  const showWorkflows = !isMETParent || managedEventTypeWorkflowsEnabled || hasWorkflows;
  return <Container>
      {showWorkflows && <AdvancedNotificationSection workflows={workflows} />}
      <BasicNotificationsSection doNotSlideBackOnToggleUpdate onSubmit={onSubmit} />
    </Container>;
};

require("./notifications.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./notifications.js");